import { UpperCasePipe } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ProviderDataReview } from 'app/core/models/provider-data-review.model';
import { ProviderDataReviewAssignmentsComponent } from '../provider-data-review-assignments/provider-data-review-assignments.component';
import { ProviderDataReviewsService } from 'app/core/services/provider-data-reviews.service';
import { NavigationService } from 'app/core/services/navigation.service';
import { BlankValueDashPipe } from 'app/shared/pipes/blank-value-dash.pipe';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { Provider } from 'app/core/models/provider.model';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { interval } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ProviderService } from 'app/core/services/provider.service';

const humanizedReviewTypeMapping = {
  'ProviderFaxNumberDataReview': 'fax number data review',
  'ProviderSpecialtyDataReview': 'specialty data review',
};

const pollingInterval = 3000;

@Component({
    selector: 'app-provider-data-review',
    templateUrl: './provider-data-review.component.html',
    styleUrls: ['./provider-data-review.component.scss'],
    imports: [
      FaIconComponent,
      UpperCasePipe,
      BlankValueDashPipe,
      ProviderDataReviewAssignmentsComponent,
    ]
})

export class ProviderDataReviewComponent implements OnInit, OnDestroy {
  private providerDataReviewService = inject(ProviderDataReviewsService);
  private providerService = inject(ProviderService);
  private navigationService = inject(NavigationService);
  private authService = inject(AuthenticationService);

  @Input() provider: Provider;

  providerDataReview: ProviderDataReview;
  canManageProviderData = false;
  editingAssignedTo = false;

  humanizedReviewTypeMapping = humanizedReviewTypeMapping;

  pollingProviderSubscription = null;

  ngOnInit() {
    this.loadProviderDataReview();
    this.canManageProviderData = this.authService.hasPermissionTo(UserRoleName.manageProviderData);
    this.startPollingSubscription();
  }

  ngOnDestroy() {
    this.stopPolling();
  }

  onEditAssignedTo($event) {
    $event.preventDefault();
    this.editingAssignedTo = true;
  }

  onAssignedToCancel() {
    this.editingAssignedTo = false;
  }

  onAssignedToUpdate(assignedToId) {
    if (assignedToId !== this.providerDataReview.assignedTo?.id ) {
      this.providerDataReviewService.assignTo(this.providerDataReview, assignedToId).subscribe((_result) => {
        this.navigationService.reloadCurrentUrl();
      });

    } else {
      this.editingAssignedTo = false;
    }
  }

  get canAssignToProviderDataReview() {
    return this.canManageProviderData;
  }

  private loadProviderDataReview() {
    this.providerDataReview = this.getOpenProviderDataReview(this.provider);
  }

  private getOpenProviderDataReview(provider) {
    return provider.providerDataReviews.find( r => r.status === 'open' );
  }

  private startPollingSubscription() {
    this.pollingProviderSubscription = interval(pollingInterval)
      .pipe(mergeMap(() => this.providerService.get(this.provider.id)))
      .subscribe(provider => {
        const openReview = this.getOpenProviderDataReview(provider);
        if (openReview) {
          if (openReview.id !== this.providerDataReview?.id) {
            this.providerDataReview = openReview;
          }
        } else {
          this.providerDataReview = null;
        }
      });
  }

  private stopPolling() {
    this.pollingProviderSubscription?.unsubscribe();
  }
}